import useAppTranslation from "@hooks/language/useAppTranslation";
import { Button } from "@mantine/core";
import { IconArrowRight } from "@tabler/icons-react";

interface IReadMoreProps {
  className?: string;
}

const ReadMore: React.FC<IReadMoreProps> = ({ className }) => {
  const { t } = useAppTranslation("common.buttons");
  return (
    <Button
      className={className}
      classNames={{
        root: "w-min font-medium bg-secret-blue-default text-primary-white hover:bg-secret-blue-default hover:text-primary-dark-text",
      }}
      radius="md"
      rightSection={<IconArrowRight />}
    >
      {t("readMore")}
    </Button>
  );
};

export default ReadMore;
